import { DeviceConfig, DeviceTypes, AllConfig } from "../../config";
import { PoolDeviceInterface, IOnoffable, IProbe } from "../Interfaces";
import Locale from "../../utils/Locale";
import PoolDeviceOnOffable from "./base-onoffable";
import { StatesToDisplayItem, PoolDeviceCriticalDesiredActual, DisplayProcessingLogics, StateMap } from "../Types";
import { ValueAndUnit } from "../../types";
import { State } from "../../status/Types";
import { AlertRecord } from "../../alert";

export enum criticalFieldIdentifiers {
    OnOff = "OnOff"
}

export default class PoolDeviceORPProbe extends PoolDeviceOnOffable implements PoolDeviceInterface, IOnoffable, IProbe {
    static CanBeAddedToflow = true;
    static Icon = "sensor-orp";
    static DeviceType = DeviceTypes.ORPPROBE;
    OnOffIdentifier = criticalFieldIdentifiers.OnOff;
    static PickerTitle = Locale.gettext("ORP Probe");

    isCalibrated(): boolean {
        return this.getDeviceState(PoolsideDaemonDeviceStateNames.Calibrated)?.value >= 1;
    }

    getCriticalFields(): PoolDeviceCriticalDesiredActual[] {
        let order = 0;
        const fields = [];
    
        {
            const DisplayName = Locale.gettext("Power");
            const common = {
                DisplayName, DisplayNameShort: DisplayName,
                DisplayOrder: ++order,
                DisplayProcessingLogic: DisplayProcessingLogics.ONOFF,
                DisplayProcessingLogicUnitAsDisplayName: false,
            };
            fields.push({
                Identifier: criticalFieldIdentifiers.OnOff,
                ActualProperty: Object.assign({ Name: PoolsideDaemonDeviceStateNames.ActualPowerState }, common),
                DesiredProperty: Object.assign({ Name: PoolsideDaemonDeviceStateNames.PowerState }, common)
            });
        }
    
        return fields;
    }
    
    getInformationFields(): StatesToDisplayItem[] {
        let order = 0;
        const fields = [];
    
        {
            const common = {
                DisplayName: "Sensor Value",
                DisplayNameShort: "Value",
                DisplayOrder: ++order,
                DisplayProcessingLogic: DisplayProcessingLogics.MV,
                DisplayProcessingLogicUnitAsDisplayName: false,
            };
            fields.push(Object.assign({ Name: PoolsideDaemonDeviceStateNames.RawValue }, common));
        }
        if (this.siteStates.AutoFilterVersion >= 12 && this.deviceConfig?.HardwareDevice?.ProbeSettings?.Tweak) {
            const common = {
                DisplayName: "Adjusted Value",
                DisplayNameShort: "Adjusted",
                DisplayOrder: ++order,
                DisplayProcessingLogic: DisplayProcessingLogics.MV,
                DisplayProcessingLogicUnitAsDisplayName: false,
            };
            fields.push(Object.assign({ Name: PoolsideDaemonDeviceStateNames.Value }, common));
        }
    
        return fields;
    }
}

export enum PoolsideDaemonDeviceStateNames {
    ActualPowerState = "ActualPowerState",
    PowerState = "PowerState",
    Calibrated = "Calibrated",
    RawValue = "RawValue",
    Value = "Value",
}
